import {
  convertToTableData,
  formatExpenseTableData,
  getMonthIntervals,
} from "@taabl/common-lib/transformers/ExpenseReport";
import React, { useEffect, useState } from "react";
import { Button, Card, Dropdown, Tab, Tabs } from "react-bootstrap";
import "react-bootstrap-multiselect/css/bootstrap-multiselect.css";
import BootstrapTable from "react-bootstrap-table-next";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import { MdReplay } from "react-icons/md";
import { toast } from "react-toastify";
import ContributionType from "../components/ContributionType";
import DropdownMenu from "../components/DropdownMenu";
import EmployeeId from "../components/EmployeeId";
import Modifications from "../components/Modifications";
import PageLoader from "../components/PageLoader";
import PaginationTable from "../components/PaginationTable";
import { Constants } from "../libs/Constants";
import { getList } from "../libs/dbFunctions";
import { getDefaultPeriodSelection } from "../libs/periodLib";
import { exportExpense } from "../libs/RequestFunctions";
import {
  constructPeriodForDisplay,
  convertDate,
  formatCurrency,
  getQueryParams,
  numberWithCommas,
} from "../libs/utils";
import "./ExpenseDashboard.scss";
const moment = require("moment");

function useLoadMoreDataFunctionAsState(fn) {
  let addGuard = (fn) => {
    return (lastKey, tableData) => {
      !!lastKey && fn(lastKey, tableData);
    };
  };

  const [val, setVal] = useState(() => addGuard(fn));

  function setFunc(fn) {
    setVal(() => addGuard(fn));
  }

  return [val, setFunc];
}

export default function AdminDashboard(props) {
  const columns = [
    {
      dataField: "type",
      sort: false,
      text: "S",
      classes: "ps-1",
      formatter: (cell) => {
        return <ContributionType ctype={cell}></ContributionType>;
      },
      footer: "Totals",
    },
    {
      dataField: "userId",
      text: "Employee ID",
      sort: false,
      classes: "col-empid",
      formatter: (cell) => {
        return <EmployeeId userid={cell}></EmployeeId>;
      },
      footer: (columnData) => {
        let unique = columnData.filter((item, i, ar) => ar.indexOf(item) === i);
        return `${unique.length} Users`;
      },
    },
    {
      dataField: "employeeName",
      sort: false,
      headerStyle: () => {
        return { width: "150px" };
      },
      text: "Employee Name",
      hidden: false,
      footer: "",
    },
    {
      dataField: "costCenter",
      sort: false,
      text: "Cost Center",
      headerStyle: () => {
        return { width: "200px" };
      },
      hidden: false,
      footer: "",
    },
    {
      dataField: "subsidiary",
      sort: false,
      text: "Subsidiary",
      headerStyle: () => {
        return { width: "200px" };
      },
      hidden: false,
      footer: "",
    },
  ];
  const colSelectdata = {
    label: "Showing All Columns",
    value: "showAll",
    checked: true,
    isDefaultValue: true,
    expanded: true,
    children: [
      {
        label: "Employee Demographics",
        value: "employeeDemographics",
        checked: true,
        expanded: true,
        children: [
          {
            label: "Cost center",
            value: "costCenter",
            checked: true,
          },
          {
            label: "Subsidiary",
            value: "subsidiary",
            checked: true,
          },
        ],
      },
      {
        label: "Elections",
        value: "elections",
        checked: true,
        expanded: true,
        children: [
          {
            label: "P1",
            value: "p1",
            checked: true,
          },
          {
            label: "P2",
            value: "p2",
            checked: true,
          },
          {
            label: "P3",
            value: "p3",
            checked: true,
          },
          {
            label: "P4",
            value: "p4",
            checked: true,
          },
        ],
      },
      {
        label: "Expenses",
        value: "expenses",
        checked: true,
      },
    ],
  };
  const rowSelectData = {
    label: "All Employees",
    value: "showAll",
    isDefaultValue: true,
    expanded: true,
    children: [
      {
        label: "Current",
        checked: true,
        value: "current",
      },
      {
        label: "Withdrawals",
        checked: true,
        value: "withdrawals",
      },
      {
        label: "Terminations",
        checked: true,
        value: "terminations",
      },
    ],
  };
  const [isLoading, setIsLoading] = useState(false);
  const [isModificationLoading, setIsModificationLoading] = useState(false);
  const [periods, setPeriods] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [totals, setTotals] = useState(null);
  const [tableColumns, setTableColumns] = useState([...columns]);
  const [offer, setOffer] = useState({});
  const [types, setTypes] = useState(["showAll"]);
  const [searchItem, setSearchItem] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["showAll"]);
  const [totalTranche, setTotalTranche] = useState(4);
  const [columnSelected, setColumnSelected] = useState(colSelectdata);
  const [rowsSelected, setRowsSelected] = useState(rowSelectData);
  const [purchasePeriod, setPurchasePeriod] = useState(0);
  const [key, setKey] = useState("expenses");
  const [modifications, setModifications] = useState(null);
  const [currentModifications, setCurrentModifications] = useState(null);
  const [mTranche, setMTranche] = useState(null);
  const [plan, setPlan] = useState(null);
  const [exportModifications, setExportModifications] = useState(false);
  const [lastKey, setLastKey] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [trauncheList, setTrancheList] = useState([]);
  const [
    loadMoreDataFunc,
    setLoadMoreDataFunc,
  ] = useLoadMoreDataFunctionAsState(null);
  const [currentTranche, setCurrentTranche] = useState(0);
  const [periodDropdown, setPeriodDropdown] = useState({
    fieldName: "periodSelected",
    type: "dropdown",
    options: [
      {
        key: Constants.ESPP_CONTRIBUTION_TYPE,
        value: "Offering Period",
      },
      {
        key: Constants.ESPP_PURCHASE_TYPE,
        value: "Purchase Period",
      },
    ],
  });

  // check if we need to clear the last key
  useEffect(() => {
    setLastKey(null);
    setTableData([]);
  }, [selectedPeriod, loadMoreDataFunc]);

  useEffect(() => {
    onLoad();
  }, [props.isAuthenticated, props.userObj]);

  useEffect(() => {
    if (periods && periods.length > 0) {
      populatePeriodFilter();

      // check any query param filter applied
      let urlParams = getQueryParams(window.location.search);
      if (urlParams?.op) {
        try {
          let offeringPeriodStart = parseInt(urlParams?.op);
          if (
            offeringPeriodStart > 0 &&
            periods.find((p) => p.periodStartdate === offeringPeriodStart)
          ) {
            setSelectedPeriod({
              period: periods.find(
                (p) => p.periodStartdate === offeringPeriodStart
              ),
              type: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
            });
            return;
          }
        } catch (err) {}
      } else if (urlParams?.period) {
        try {
          let purchasePeriodStart = parseInt(urlParams?.period);
          if (
            purchasePeriodStart > 0 &&
            periods.find((p) => p.periodStartdate === purchasePeriodStart)
          ) {
            setSelectedPeriod({
              period: periods.find(
                (p) => p.periodStartdate === purchasePeriodStart
              ),
              type: Constants.PERIOD_DISPLAY_TYPES.PURCHASE,
            });
            return;
          }
        } catch (err) {}
      }
      setDefaultPeriod();
    }
  }, [periods]);

  useEffect(() => {
    if (selectedPeriod && Object.keys(selectedPeriod).length > 0) {
      let sPeriod = selectedPeriod.period;
      if (selectedPeriod.type === Constants.PERIOD_DISPLAY_TYPES.PURCHASE) {
        loadContributionForPurchasePeriod(sPeriod);
        // set function that will be called to load additional pages of data
        setLoadMoreDataFunc((lastKey, tableData) => {
          loadContributionForPurchasePeriod(sPeriod, lastKey, tableData);
        });
        loadModifications({
          periodStartDate: sPeriod.periodStartdate,
          periodEndDate: sPeriod.periodEnddate,
        });
        loadSummary(
          sPeriod.periodStartdate,
          sPeriod.periodEnddate,
          selectedPeriod.type
        );
      } else {
        loadContributionsForOfferPeriod(sPeriod.periodStartdate);
        // set function that will be used to load additional pages of data
        setLoadMoreDataFunc((lastKey, tableData) => {
          loadContributionsForOfferPeriod(
            sPeriod.periodStartdate,
            lastKey,
            tableData
          );
        });
        loadModifications({ offerStartdate: sPeriod.periodStartdate });
      }
    }
  }, [selectedPeriod]);

  useEffect(() => {
    // Show hide columns
    if (offer) {
      let trancheArray = [];
      if (
        selectedPeriod &&
        selectedPeriod.type === Constants.PERIOD_DISPLAY_TYPES.PURCHASE
      ) {
        trancheArray = [currentTranche];
      } else {
        for (let i = 0; i < totalTranche; i++) trancheArray.push(i);
      }
      setTrancheList(trancheArray);
      generateTableColumn(
        offer.offerStartdate,
        offer.offerEnddate,
        trancheArray
      );
    }
  }, [selectedColumns]);

  function setDefaultPeriod() {
    let periodResponse = getDefaultPeriodSelection(periods);
    if (periodResponse) {
      setSelectedPeriod({
        period: periods.find(
          (p) =>
            p.periodStartdate == periodResponse.currentPeriod.periodStartdate
        ),
        type: Constants.PERIOD_DISPLAY_TYPES.PURCHASE,
      });
    }
  }

  async function loadModifications(params) {
    setIsModificationLoading(true);
    try {
      let modifications = await getList(
        Constants.dbTypes.MODIFICATION,
        props.activeCompany,
        params
      );
      if (modifications && modifications.length > 0) {
        setModifications(modifications);
        setCurrentModifications(modifications);
      } else {
        setModifications([]);
        setCurrentModifications([]);
      }
    } catch (e) {
      toast.error(e);
    }
    setIsModificationLoading(false);
  }

  function populatePeriodFilter() {
    let options = [
      {
        key: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
        value: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
        children: [],
      },
      {
        key: Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE,
        value: Constants.PURCHASE_PERIOD_DISPLAY_TYPES.PURCHASE,
        children: [],
      },
    ];
    if (periods && periods.length > 0) {
      options[1].children = periods.map((period) => {
        return {
          itemKey: "" + period.periodStartdate,
          type: Constants.PERIOD_DISPLAY_TYPES.PURCHASE,
          title: constructPeriodForDisplay(
            period,
            props.activeCompany?.timezone
          ),
        };
      });
      //Now we know we have ateast one period
      let totalOfferingPeriod = periods.length - totalTranche + 1;
      options[0].children = [];
      for (let i = 0; i < totalOfferingPeriod; i++) {
        let offeringPeriod = {
          itemKey: "" + periods[i].periodStartdate,
          type: Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION,
          title: constructPeriodForDisplay(
            periods[i],
            props.activeCompany?.timezone
          ),
        };
        options[0].children.push(offeringPeriod);
      }
      setPeriodDropdown(Object.assign(periodDropdown, { options }));
    }
  }

  async function onLoad() {
    try {
      props.setPageLoading(true);
      await getPlan();
      const periodsResponse = await getList(
        Constants.dbTypes.PERIOD,
        props.activeCompany
      );
      if (periodsResponse && periodsResponse.length > 0) {
        setPeriods(periodsResponse);
      }
    } catch (e) {
      toast.error(e);
    }
    props.setPageLoading(false);
  }
  async function getPlan() {
    try {
      const planDetail = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        props.activeCompany
      );
      let trancheCount = 0;
      let pperiod = 0;
      if (planDetail && planDetail.length > 0) {
        pperiod = Number(planDetail[0].purchasePeriod);

        setPurchasePeriod(pperiod);
        trancheCount =
          Number(planDetail[0].lookBack) / Number(planDetail[0].purchasePeriod);
        setTotalTranche(trancheCount);
        setPlan(planDetail[0]);
      }
    } catch (e) {
      toast.error(e);
    }
  }
  async function loadContributionsForOfferPeriod(
    offerStartdate,
    lastKey,
    tableData
  ) {
    // make API call to get reports
    // only show loading indicator if this is the first batch of data we are retreiving, otherwise we'll load it silently in the background
    setIsLoading(true && !lastKey);
    setErrorMessage("");
    try {
      let contributions = await getList(
        Constants.dbTypes.OFFERING_PERIOD_CONTRIBUTIONS,
        props.activeCompany,
        {
          offerStartdate: offerStartdate,
          paginate: true,
          lastKey: lastKey ? lastKey : null,
        }
      );

      if (contributions && contributions.length && contributions.lastKey) {
        setLastKey(contributions.lastKey);
      } else {
        setLastKey(null);
      }

      if (contributions && contributions.length > 0) {
        let trancheArray = [];
        for (let i = 0; i < totalTranche; i++) trancheArray.push(i);
        constructSelectAllColumnTree(trancheArray);
        setTrancheList(trancheArray);
        setOffer({
          offerStartdate: contributions[0].offerStartdate,
          offerEnddate: contributions[0].purchaseExpiration,
        });
        setIsLoading(false);
        formatTableData(contributions, tableData ? tableData : null);
        loadSummary(
          contributions[0].offerStartdate,
          contributions[0].purchaseExpiration,
          Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION
        );
      } else {
        setIsLoading(false);
        return;
      }

      setSelectedColumns(["showAll"]);
    } catch (e) {
      setErrorMessage("Error loading contributions for this period.");
      toast.error(e);
      setIsLoading(false);
      return;
    }
  }

  async function loadContributionForPurchasePeriod(
    currentPeriod,
    lastKey,
    tableData
  ) {
    // only show loading indicator if this is the first batch of data we are retreiving, otherwise we'll load it silently in the background
    setIsLoading(true && !lastKey);
    setErrorMessage("");
    if (currentPeriod) {
      try {
        let contributions = await getList(
          Constants.dbTypes.OFFERING_PERIOD_CONTRIBUTIONS,
          props.activeCompany,
          {
            periodStartdate: currentPeriod.periodStartdate,
            periodEnddate: currentPeriod.periodEnddate,
            paginate: true,
            lastKey: lastKey ? lastKey : null,
          }
        );
        if (contributions && contributions.length && contributions.lastKey) {
          setLastKey(contributions.lastKey);
        } else {
          setLastKey(null);
        }
        if (contributions && contributions.length > 0) {
          let currentTranche = findCurrentTranche(
            contributions[0].offerStartdate,
            currentPeriod
          );
          setCurrentTranche(currentTranche);

          setMTranche(currentTranche);
          constructSelectAllColumnTree([currentTranche]);
          generateTableColumn(
            currentPeriod.periodStartdate,
            currentPeriod.periodEnddate,
            [currentTranche]
          );

          formatTableData(contributions, tableData ? tableData : null);
        }
      } catch (e) {
        setErrorMessage("Error loading contributions for this period.");
        toast.error(e);
      }
    }
    setIsLoading(false);
  }

  async function loadSummary(periodStartDate, periodEndDate, periodType) {
    try {
      let params = {
        summaryType: Constants.SUMMARY_TYPE.EXPENSE,
        startdate: periodStartDate,
        enddate: periodEndDate,
        periodType,
      };
      let expenseDetails = await getList(
        Constants.dbTypes.SUMMARY,
        props.activeCompany,
        params
      );

      setTotals(expenseDetails);
    } catch (e) {
      toast.error(e);
    }
  }

  function constructSelectAllColumnTree(trancheArray) {
    let newColSelectdata = { ...colSelectdata };
    // Get elections children
    let elections = newColSelectdata.children.find(
      (c) => c.value === "elections"
    );
    elections.children = [];
    for (let i of trancheArray) {
      elections.children.push({
        label: `P${i + 1}`,
        value: `p${i + 1}`,
        checked: true,
      });
    }
    setColumnSelected(newColSelectdata);
  }

  function generateTableColumn(startDate, endDate, trancheArray) {
    let tColumns = [
      ...columns,
      {
        dataField: "start",
        sort: false,
        headerStyle: () => {
          return { width: "150px" };
        },
        formatter: (cell) => {
          return convertDate(
            cell,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            props.activeCompany?.timezone
          );
        },
        text: "Offering Start",
        footer: "",
      },
      {
        dataField: "end",
        sort: false,
        text: "Offering End",
        formatter: (cell) => {
          return convertDate(
            cell,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            props.activeCompany?.timezone
          );
        },
        headerStyle: () => {
          return { width: "150px" };
        },
        footer: "",
      },
      {
        dataField: "stockPrice",
        sort: false,
        text: "Stock Price",
        formatter: (cell) => {
          return formatCurrency(cell);
        },
        footer: "",
      },
      {
        dataField: "orgPrice",
        sort: false,
        text: "Purchase Price",
        formatter: (cell) => {
          return formatCurrency(cell);
        },
        footer: "",
      },
    ];

    let mutableColList = ["subsidiary", "costCenter", "expenses"];
    for (let i of trancheArray) {
      mutableColList.push(`p${i + 1}`);
      if (
        selectedPeriod &&
        selectedPeriod.type === Constants.PERIOD_DISPLAY_TYPES.PURCHASE
      ) {
        tColumns.push({
          dataField: `election`,
          sort: false,
          hidden: false,
          text: `Elect.`,
          headerStyle: () => {
            return { width: "150px" };
          },
          formatter: (cell) => {
            return formatCurrency(cell);
          },
          footer: (columnData) =>
            formatCurrency(columnData.reduce((acc, item) => acc + item, 0)),
        });
        tColumns.push({
          dataField: `shares`,
          sort: false,
          hidden: false,
          text: `Shares`,
          footer: (columnData) =>
            numberWithCommas(columnData.reduce((acc, item) => acc + item, 0)),
        });
        tColumns.push({
          dataField: `value`,
          sort: false,
          hidden: false,
          text: `Value`,
          formatter: (cell) => {
            return formatCurrency(cell);
          },
          footer: "",
        });
      } else {
        tColumns.push({
          dataField: `election${i + 1}`,
          sort: false,
          hidden: false,
          text: `P${i + 1} Elect.`,
          headerStyle: () => {
            return { width: "150px" };
          },
          formatter: (cell) => {
            return formatCurrency(cell);
          },
          footer: (columnData) =>
            formatCurrency(columnData.reduce((acc, item) => acc + item, 0)),
        });
        tColumns.push({
          dataField: `shares${i + 1}`,
          sort: false,
          hidden: false,
          text: `P${i + 1} Shares`,
          footer: (columnData) =>
            numberWithCommas(columnData.reduce((acc, item) => acc + item, 0)),
        });
        tColumns.push({
          dataField: `value${i + 1}`,
          sort: false,
          hidden: false,
          text: `P${i + 1} Value`,
          formatter: (cell) => {
            return formatCurrency(cell);
          },
          footer: "",
        });
      }
    }

    tColumns.push({
      dataField: `totalValue`,
      sort: false,
      text: `Tot. Value`,
      headerStyle: () => {
        return { width: "150px" };
      },
      formatter: (cell) => {
        return formatCurrency(cell);
      },
      footer: (columnData) =>
        formatCurrency(columnData.reduce((acc, item) => acc + item, 0)),
    });

    tColumns.push({
      dataField: `periodDays`,
      sort: false,
      text: `Off. Per. Days`,
      footer: "",
    });

    tColumns.push({
      dataField: `costPerDay`,
      sort: false,
      text: `Cost Per Day`,
      formatter: (cell) => {
        return formatCurrency(cell);
      },
      footer: (columnData) =>
        formatCurrency(columnData.reduce((acc, item) => acc + item, 0)),
    });

    let monthsArray = getMonthIntervals(
      startDate,
      endDate,
      props.activeCompany.timezone
    );
    for (let month of monthsArray) {
      tColumns.push({
        dataField: convertDate(
          month.lastDayofMonth,
          Constants.DATEFORMAT.MMDDYYYY,
          false,
          props.activeCompany?.timezone
        ),
        sort: false,
        headerStyle: () => {
          return { width: "150px" };
        },
        formatter: (cell) => {
          if (!cell) {
            return "-";
          }
          return formatCurrency(cell);
        },
        text: convertDate(
          month.lastDayofMonth,
          Constants.DATEFORMAT.MMDDYYYY,
          false,
          props.activeCompany?.timezone
        ),
        hidden: false,
        footer: (columnData) =>
          formatCurrency(
            columnData.reduce((acc, item) => acc + (item || 0), 0)
          ),
      });
    }

    let field = null;
    if (selectedColumns) {
      if (!selectedColumns.includes("showAll")) {
        for (let col of mutableColList) {
          if (selectedColumns.indexOf(col) < 0) {
            tColumns = tColumns.filter((column) => {
              field = column.text.toLowerCase();
              if (col === "subsidiary" || col === "costCenter")
                return column.dataField !== col;
              if (col.startsWith("p")) {
                if (!field.startsWith(col)) return column;
              }
              if (col === "expenses") {
                if (!field.includes("/")) {
                  return column;
                }
              }
            });
          }
        }
      }
    }

    setTableColumns(tColumns);

    setIsLoading(false);
  }

  function formatTableData(additionalContributions, currentTableData) {
    if (
      periods &&
      additionalContributions &&
      additionalContributions.length > 0
    ) {
      setOffer({
        offerStartdate: additionalContributions[0].offerStartdate,
        offerEnddate: additionalContributions[0].purchaseExpiration,
      });
    }
    let tableRows;
    try {
      tableRows = formatExpenseTableData(
        props.activeCompany.timezone,
        periods,
        selectedPeriod,
        additionalContributions,
        types,
        totalTranche
      );

      // add new table rows to currentTableData if it exists
      if (currentTableData) {
        tableRows = currentTableData.concat(tableRows);
      }
    } catch (e) {
      console.log("error formatting table rows", e);
    }

    setTableData(tableRows);
    setIsLoading(false);
  }

  async function exportToExcel() {
    if (key === "modifications") {
      // if (modifications && modifications.length > 0) {
      //   setExportModifications(!exportModifications);
      // } else toast.error("No Modifications to export.");
      toast.error("Currently we can't export modifications.");
    } else {
      exportToFile();
    }
  }
  function exportTaablToExcel() {
    if (key === "modifications") {
      toast.error("Can't export modifications for Taabl.");
      return;
    }
    exportToFile();
  }

  function exportToFile() {
    let totalPeriods = totalTranche;
    let start = offer.offerStartdate;
    let end = offer.offerEnddate;
    if (selectedPeriod && selectedPeriod.type === "Purchase") {
      totalPeriods = 1;
      start = selectedPeriod.period.periodStartdate;
      end = selectedPeriod.period.periodEnddate;
    }
    let promise = exportExpense(
      offer.offerStartdate,
      periods,
      selectedPeriod,
      totalTranche,
      start,
      end,
      trauncheList,
      totalPeriods,
      props.activeCompany
    );
    promise.then((val) => {
      let bod = JSON.parse(val.body);
      window.open(bod.url);
    });
  }

  async function resetFilters() {
    setDefaultPeriod();
    if (searchItem) setSearchItem(null);

    setTypes(["showAll"]);
    setSelectedColumns(["showAll"]);
    setColumnSelected(colSelectdata);
    setRowsSelected(rowSelectData);
  }
  function handleAllChildren(parent, checked) {
    if (parent && "children" in parent && parent.children) {
      for (let child of parent.children) {
        child.checked = checked;
        if ("children" in child && child.children) {
          handleAllChildren(child, checked);
        }
      }
    }
  }
  function onChangeColumns(currentNode, selectedNodes) {
    let selectedCol = selectedNodes.map((node) => {
      return node.value;
    });
    let colData = Object.assign(columnSelected);
    let columns = [];

    for (let col of selectedCol) {
      if (col === "showAll") {
        columns.push(col);
        colData = Object.assign(colData, {
          label: "Showing All Columns",
          checked: true,
        });
        handleAllChildren(colData, true);
      } else {
        colData = Object.assign(colData, {
          label: "Hiding Some Columns",
          checked: false,
        });
        if ("children" in colData && colData.children) {
          for (let child1 of colData.children) {
            if (child1.value === currentNode.value) {
              child1.checked = currentNode.checked;
              handleAllChildren(child1, currentNode.checked);
            }
            if (col === child1.value) {
              if ("children" in child1 && child1.children) {
                child1.children.map((item) => {
                  columns.push(item.value);
                });
              } else {
                columns.push(child1.value);
              }
            } else {
              if ("children" in child1 && child1.children) {
                for (let child2 of child1.children) {
                  if (child2.value === currentNode.value) {
                    child2.checked = currentNode.checked;
                    handleAllChildren(child2, currentNode.checked);
                  }
                  if (col === child2.value) {
                    if ("children" in child2 && child2.children) {
                      child2.children.map((item) => {
                        columns.push(item.value);
                      });
                    } else columns.push(child2.value);
                  }
                }
              }
            }
          }
        }
      }
    }
    setColumnSelected(colData);
    setSelectedColumns(columns);
  }

  function onChangeRows(currentNode, selectedNodes) {
    let selectedTypes = [];
    selectedNodes.map((node) => selectedTypes.push(node.value));
    let selected = Object.assign(rowsSelected);
    for (let child of selected.children) {
      if (currentNode && currentNode.value === child.value) {
        child.checked = currentNode.checked;
      }
    }
    if (!selectedTypes.includes("showAll")) {
      selected.label = "Hiding Some rows";
    } else {
      selected.label = "All Employees";
    }
    setRowsSelected(selected);
    setTypes(selectedTypes);
  }

  function handleSearch(e) {
    setSearchItem(e.target.value);
  }

  function findCurrentTranche(startDate, currentPeriod) {
    let currentTranche = 0;
    for (let i = 0; i < totalTranche; i++) {
      let offerStartdate = moment
        .utc(startDate)
        .add(purchasePeriod * i, "months");
      if (
        currentPeriod.periodStartdate >=
          offerStartdate.startOf("day").valueOf() &&
        currentPeriod.periodStartdate < offerStartdate.endOf("day").valueOf()
      ) {
        currentTranche = i;
        break;
      }
    }
    return currentTranche;
  }

  function handlePeriodSelect(e) {
    let period = periods.find((p) => p.periodStartdate === parseInt(e.itemKey));
    setSelectedPeriod({ type: e.type, period });
  }

  function renderExpenses() {
    return (
      <PaginationTable
        increment={25}
        onNeedMoreData={() => loadMoreDataFunc(lastKey, tableData)}
        totalRow={tableData?.length}
      >
        {({ paginationTableProps }) => (
          <BootstrapTable
            bootstrap4={true}
            wrapperClasses="table-expenses"
            classes="table-taabl"
            keyField="id"
            bordered={false}
            data={convertToTableData(tableData)}
            columns={tableColumns}
            {...paginationTableProps}
          />
        )}
      </PaginationTable>
    );
  }
  function renderModifications() {
    let trancheArray = [];
    if (
      !selectedPeriod ||
      selectedPeriod.type !== Constants.PERIOD_DISPLAY_TYPES.PURCHASE
    ) {
      for (let i = 0; i < totalTranche; i++) trancheArray.push(i);
    } else {
      trancheArray = [mTranche];
    }
    //setTrancheList(trancheArray);
    return (
      <Modifications
        period={periods}
        offer={offer}
        selectedPeriod={selectedPeriod}
        purchasePeriod={purchasePeriod}
        totalTranche={totalTranche}
        trancheArray={trancheArray}
        modifications={currentModifications}
        types={types}
        searchItem={searchItem}
        selectedColumns={selectedColumns}
        activeCompany={props.activeCompany}
        exportToExcel={exportModifications}
      />
    );
  }
  function renderTotals() {
    return (
      <div className="d-flex justify-content-end flex-column flex-sm-row pt-4">
        <div className="d-flex flex-column flex-sm-row pt-4 bottom-cal">
          <div className="boot-txt p-2">
            <h4>Total Fair Value:</h4>
            <p>{formatCurrency(totals.totalFairValue)}</p>
          </div>
          <div className="boot-txt p-2">
            <h4>Total Expense:</h4>
            <p>{formatCurrency(totals.totalExpenses)}</p>
          </div>
          <div className="boot-txt p-2">
            <h4>Total Modification Charge:</h4>
            <p>{formatCurrency(totals.totalModificationCharge)}</p>
          </div>
          <div className="boot-txt p-2">
            <h4>Average Cost/Day:</h4>
            <p>{formatCurrency(totals.avgCostPerDay)}</p>
          </div>
          <div className="boot-txt p-2">
            <h4>Average Contribution Election:</h4>
            <p>
              {formatCurrency(totals.avgContributionElection)}|{" "}
              {totals.totalShares} Shares
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <PageLoader isActive={isLoading}>
      <div>
        <Card>
          <Card.Body>
            <Card.Title as="h2" className="mb10">
              Expense Table
            </Card.Title>

            {!isLoading && !periods && tableData && tableData.length === 0 && (
              <div>
                {" "}
                There is no Contribution data available for this Company.
              </div>
            )}
            {!isLoading && periods && plan && (
              <React.Fragment>
                <div className="pb-2">
                  <div className="d-flex flex-column flex-sm-row flex-wrap justify-content-between align-items-center m-0">
                    {/* <div className="justify-content-between m-0 row"> */}
                    <div className="me-3 mb-3">
                      <Dropdown>
                        <Dropdown.Toggle variant="taabl" id="dropdown-basic">
                          Employee View
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#/action-1" active>
                            Employee View
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="me-3 mb-3">
                      <DropdownMenu
                        open={openMenu}
                        onClick={(e) => {
                          handlePeriodSelect(e);
                        }}
                        onClose={() => {
                          setOpenMenu(false);
                        }}
                        onOpen={() => {
                          setOpenMenu(true);
                        }}
                        topKey="selectedPeriod"
                        config={[
                          {
                            title: constructPeriodForDisplay(
                              selectedPeriod?.period,
                              props.activeCompany?.timezone,
                              selectedPeriod?.type
                            ),
                            itemKey: "selectedPeriod",
                            submenu: periodDropdown.options.map((f) => ({
                              title: f.value,
                              itemKey: f.key,
                              submenu: f.children,
                            })),
                          },
                        ]}
                      />
                    </div>
                    <div className="me-3 mb-3">
                      <DropdownTreeSelect
                        className="taabl"
                        data={columnSelected}
                        onChange={onChangeColumns}
                        texts={{ placeholder: "All Columns" }}
                      />
                    </div>

                    {/* TODO: Add support for filtering paginated data and unhide these elements */}
                    <div className="me-auto mb-3"></div>
                    <div className="hide">
                      <div className="me-3 mb-3">
                        <DropdownTreeSelect
                          className="taabl"
                          data={rowsSelected}
                          onChange={onChangeRows}
                          texts={types}
                        />
                      </div>

                      <div className="serc-bx">
                        <form className="search-form" id="search-form">
                          <input
                            type="text"
                            className="searchbox"
                            onFocus={(e) =>
                              (e.target.placeholder =
                                "Search for Name, Department, etc.")
                            }
                            onBlur={(e) => (e.target.placeholder = "")}
                            onInput={handleSearch}
                          />
                        </form>
                      </div>
                      <div className="me-auto mb-3">
                        <Button className="btn-reset" onClick={resetFilters}>
                          Reset Filters <MdReplay />
                        </Button>
                      </div>
                    </div>
                    <div className="Viewdropdown">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="taabl-secondary"
                          id="dropdown-basic"
                        >
                          Export Current View
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="taabl">
                          <Dropdown.Item onSelect={exportToExcel} active>
                            Export Current View
                          </Dropdown.Item>
                          <Dropdown.Item onSelect={exportTaablToExcel}>
                            Export Taabl Users
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="mt-1 pt-1">
                  <Tabs
                    id="controlled-tab"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    variant="taabl"
                  >
                    <Tab eventKey="expenses" title="Expenses">
                      <div className="me-3 mt-5">
                        {!isLoading &&
                          (!tableData || tableData.length === 0) && (
                            <div>
                              {errorMessage
                                ? errorMessage
                                : "No contributions for this company in the given Period."}
                            </div>
                          )}
                        {!isLoading &&
                          periods &&
                          tableData &&
                          tableData.length > 0 &&
                          renderExpenses()}
                      </div>
                      {totals &&
                        tableData &&
                        tableData.length > 0 &&
                        renderTotals()}
                    </Tab>
                    <Tab eventKey="modifications" title="Modifications">
                      <PageLoader
                        individual={true}
                        isActive={isModificationLoading}
                      >
                        {!isModificationLoading &&
                          (!currentModifications ||
                            currentModifications.length === 0) && (
                            <div className="me-3 mt-5">
                              No modifications for this company in the given
                              Period.
                            </div>
                          )}

                        {!isModificationLoading &&
                          currentModifications &&
                          currentModifications.length > 0 &&
                          offer &&
                          key &&
                          key === "modifications" &&
                          renderModifications()}
                      </PageLoader>
                    </Tab>
                  </Tabs>
                </div>
              </React.Fragment>
            )}
          </Card.Body>
        </Card>
      </div>
    </PageLoader>
  );
}
